import axios from "axios";

const token = process.env.REACT_APP_RELOOK_SECRET;

export const relookBackendInstance = axios.create({
	baseURL: process.env.REACT_APP_RELOOK_API_URL,
});

relookBackendInstance.interceptors.request.use((config) => {
	config.headers.Authorization = `Bearer ${token}`;
	return config;
});
